export default "__VITE_ASSET__DUERaA$C__"